import cn from 'classnames';

import styles from './Option.module.scss';

interface IOptionProps {
  name: string;
  code?: string;
  isSelected: boolean;
  onClick: () => void;
}

const Option = ({ name, code, isSelected, onClick }: IOptionProps) => {
  return (
    <li
      className={cn(
        styles.option,
        isSelected ? styles.optionSelected : undefined
      )}
      tabIndex={0}
      onClick={onClick}
      onKeyDown={event => {
        event.stopPropagation();
        if (event.key === 'Enter' || event.key === ' ') {
          onClick();
        }
      }}
    >
      {name} {code}
    </li>
  );
};

export default Option;
